<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #layoutContent>
      <Card :title="cardTitle" containerClass="mb-5 mt-5">
        <template #cardToolbar>
          <div class="d-flex justify-content-end align-items-center">
            <div class="d-flex justify-content-center">
              <DateRangePicker id="Date_range_picker_historics" @update:date="handleRangeDate" />
            </div>
          </div>
        </template>
        <template #cardBody>
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                 id="historics_datatable">
            <thead class="mb-5">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-100px text-center">{{ $t('access.card.assignable_name') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.card.assigned_at') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.card.returned_at') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.card.object') }} </th>
            </tr>
            </thead>
          </table>
        </template>
      </Card>
    </template>
  </SubLayout>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/Modules/CRM/components/Card";
import DateRangePicker from "@/components/DateRangePicker.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import { useI18n } from 'vue-i18n'
import {useRoute} from "vue-router";

const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()
const { t } = useI18n({ useScope: 'global' })
const route = useRoute()
const title = ref("access.card.history")
const breadcrumbs = ref([
  {
    name: 'access.card.history',
    route: 'access-card-history'
  }
])

const currentCard = computed(() => {
  const cards = store.getters['cards/getCards'] || []
  return cards.find(card => card.id === route.params.id)
})

const cardTitle = computed(() => {
  if (currentCard.value && currentCard.value.card_number) {
    return `${t('access.card.history')} - ${currentCard.value.card_number}`
  }
  return t('access.card.history')
})

const table = ref()
const query = ref({
  start_date: '',
  end_date: ''
})



watch(() => locale.value, (value) => {
  nextTick(() => fetchDatas() )
}, { deep: true })

watch(() => [query.value.start_date, query.value.end_date], (newValue) => {
  table.value.ajax.url(`${BASE_URL}/get/card/${route.params.id}/assign/histories?startDate=${query.value.start_date}&endDate=${query.value.end_date}`).load()
})



function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#historics_datatable").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'desc']],
    ajax: {
      url: BASE_URL + `/get/card/${route.params.id}/assign/histories?startDate=${query.value.start_date}&endDate=${query.value.end_date}`,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [
      { data: "assignable_name" }, { data: "assigned_at" },{ data: "returned_at" }, { data: "object" }
    ],
    columnDefs: [

      {
        targets: -4,
        orderable: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -3,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -2,
        orderable: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -1,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });
}

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}


onMounted( () => {
  fetchDatas(),
  store.dispatch('cards/loadCards')
})
</script>